import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { BsSearch } from "react-icons/bs";
import { AiFillEdit } from "react-icons/ai";
import IconButton from "@mui/material/IconButton";
import { useToast } from "../../components/ui/ToastContext";
import { FaRegCheckCircle, FaRegTimesCircle } from "react-icons/fa";
import { API_URL } from "../../config";
import { jwtDecode } from 'jwt-decode';
import { logAuditUI } from "../../utils/auditLogger";

function DashboardCard14() {
  const { showToast } = useToast();

  const navigate = useNavigate();
  const [Data, setData] = useState([]);
  const [Adress, setAdress] = useState([]);
  const [Adressinst, setAdressinst] = useState([]);
  const [selectedInstitutionId, setSelectedInstitutionId] = useState(null);
  const [showGrid, setShowGrid] = useState(true);
  const [user, setUser] = useState(null);

  const getJwtFromCookies = () => {
    const cookies = document.cookie.split("; ");
    const tokenCookie = cookies.find(row => row.startsWith("accessToken="));
    return tokenCookie ? tokenCookie.split("=")[1] : null;
  };
  //const token = getJwtFromCookies();

  const token = localStorage.getItem('jwtToken');


  useEffect(() => {
    const timer = setTimeout(() => {
      setShowGrid(false); // După 1 secundă, comutăm pe grid
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

    useEffect(() => {
      if (token) {
        try {
          const decoded = jwtDecode(token);
          setUser(decoded);
        } catch (error) {
          console.error('Error decoding the token:', error);
        }
      }
    }, [token]);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adressinstitutions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setAdressinst(response.data);
        logAuditUI({
          actionType: 'VIEW_LIST',
          module: 'Institutii medicale',
          description: 'A accesat lista instituțiilor medicale',
          details: { count: Array.isArray(response.data) ? response.data.length : 0 },
        });
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/adress`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setAdress(response.data)
        // ////////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  useEffect(() => {
    axios
      .get(`${API_URL}/api/institutions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response.data)
        // ////////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  }, []);

  const fetchManageData = () => {
    axios
      .get(`${API_URL}/api/institutions`, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        setData(response.data)
        // ////////////////////////////////console.log(response.data)
      })
      .catch((error) => {
        console.error("Error fetching user data:", error);

      });
  };

  const [sortConfig, setSortConfig] = useState({
    key: 'description', // Initial sorting key
    direction: 'ascending',   // Initial sorting direction
  });

  const sortedData = [...Data].sort((a, b) => {
    if (sortConfig.key && a[sortConfig.key] !== undefined && b[sortConfig.key] !== undefined) {
      const aValue = a[sortConfig.key] !== undefined ? a[sortConfig.key] : ''; // Default to empty string if undefined
      const bValue = b[sortConfig.key] !== undefined ? b[sortConfig.key] : ''; // Default to empty string if undefined

      if (typeof aValue === "string" && typeof bValue === "string") {
        return sortConfig.direction === "ascending"
          ? aValue.localeCompare(bValue)
          : bValue.localeCompare(aValue);
      } else if (typeof aValue === "number" && typeof bValue === "number") {
        return sortConfig.direction === "ascending" ? aValue - bValue : bValue - aValue;
      } else if (sortConfig.key === "district_name") {
        return sortConfig.direction === "ascending"
          ? new Date(aValue) - new Date(bValue)
          : new Date(bValue) - new Date(aValue);
      }
    }
    return 0;
  });

  const [selecteduser, setSelecteduser] = useState(null);
  const [selecteddeleteuser, setSelecteddeleteuser] = useState(null);
  const [searchQuery1, setSearchQuery1] = useState('');
  const itemsPerPage = 100;
  const [currentPage, setCurrentPage] = useState(1);
  const total = sortedData.filter((user) => {
    const institutionIds = Adressinst
      .filter((i) => i.institution_id === user.institution_id) // Găsește toate `adress_id` asociate cu instituția
      .map((i) => i.adress_id);

    const filteredAdress = Adress.filter((i) => institutionIds.includes(i.adress_id)); // Găsește toate adresele

    // Verifică dacă oricare dintre adrese corespunde cu textul căutat
    const matchesCity = filteredAdress.some((address) =>
      address.city_name.toLowerCase().includes(searchQuery1.toLowerCase())
    );
    const matchesDistrict = filteredAdress.some((address) =>
      address.district_name.toLowerCase().includes(searchQuery1.toLowerCase())
    );

    const matchesRegion = filteredAdress.some((address) =>
      address.region_name.toLowerCase().includes(searchQuery1.toLowerCase())
    );

    // Returnează true dacă există potriviri în oricare dintre câmpuri
    return (
      user.description.toLowerCase().includes(searchQuery1.toLowerCase()) ||
      user.tip.toLowerCase().includes(searchQuery1.toLowerCase()) ||
      user.iggroup.toLowerCase().includes(searchQuery1.toLowerCase()) ||
      matchesCity || // Include potriviri pentru city_name
      matchesDistrict // Include potriviri pentru district_name
      || matchesRegion
    );
  });
  const totalPages = Math.ceil(total.length / itemsPerPage);
  const currentItems = total.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  useEffect(() => {
    if (selecteddeleteuser) {
      //////////////////////////console.log("Selected user to delete:", selecteddeleteuser);  // Aici poți verifica ce conține userul selectat
      deleteRow();
    }
  }, [selecteddeleteuser]);

  useEffect(() => {
    if (selecteduser) {
      //////////////////////////console.log("Selected user to delete:", selecteduser);  // Aici poți verifica ce conține userul selectat
      handleSave(selecteduser);
    }
  }, [selecteduser]);

  const handleSave = (item) => {
    //////////////////////////////console.log("selecteddeletecompany",);

    navigate("/institutions/editinstitution", { state: { item } });
  };

  const deleteRow = async () => {
    //////////////////////////////console.log("selecteddeletecompany",);
    try {
      await axios.put(
        `${API_URL}/api/deleteinstitutions`, { institution_id: selecteddeleteuser.institution_id }
      );

      // Așteaptă finalizarea operației înainte de a face fetch
      fetchManageData();  // Aceasta va reîmprospăta datele după ștergere
      showToast({
        message: "Datele au fost sterse cu succes!",
        type: "success",
        icon: <FaRegCheckCircle className="text-cyan-600 dark:text-cyan-500" />,
      });
      ////////////////////////////////console.log("Sters cu succes!");
    } catch (error) {
      console.error("Error saving changes:", error);
      showToast({
        message: "Eroare la inserarea datelor!",
        type: "error",
        icon: <FaRegTimesCircle className="text-red-600 dark:text-red-500" />,
      });
    }
  };

  const handleNewRows = (item) => {
    //////////////////////////////console.log(item);
    navigate("/institutions/createinstitution");
  };

  return (
    <>
      {showGrid ? (
        <div className="flex flex-row gap-2">
          <div className="animate-pulse bg-gray-300 w-14 h-14 rounded-lg"></div>
          <div className="flex flex-col gap-2">
            <div className="animate-pulse bg-gray-300 w-28 h-5 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-3 rounded-lg"></div>
            <div className="animate-pulse bg-gray-300 w-36 h-2 rounded-lg"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="col-span-full xl:col-span-12 bg-white dark:bg-gray-800 shadow-sm rounded-xl justify-center items-center">
            <header className="px-5 py-4 border-b border-gray-100 dark:border-gray-700/60 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-2 sm:gap-0">
              <div className="relative mb-4 sm:mb-0">
                <h1 className="text-2xl md:text-3xl text-gray-800 dark:text-gray-100 font-bold">Institutii</h1>
              </div>
              <div className="sm:flex sm:items-center sm:gap-4 w-full sm:w-auto">
                <div className="relative w-full sm:w-64 md:w-80">
                  <BsSearch className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" />
                  <input
                    type="text"
                    className="pl-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 focus:border-blue-500 focus:outline-none dark:bg-gray-800 dark:text-gray-200"
                    placeholder="Căutare"
                    value={searchQuery1}
                    onChange={(e) => setSearchQuery1(e.target.value)} />
                </div>
                {user && user.role === 'Admin' && (

                <button className="btn bg-gray-900 text-gray-100 hover:bg-gray-800 dark:bg-gray-100 dark:text-gray-800 dark:hover:bg-white mt-4 sm:mt-0" onClick={handleNewRows}>
                  <svg className="fill-current shrink-0 xs:hidden" width="16" height="16" viewBox="0 0 16 16">
                    <path d="M15 7H9V1c0-.6-.4-1-1-1S7 .4 7 1v6H1c-.6 0-1 .4-1 1s.4 1 1 1h6v6c0 .6.4 1 1 1s1-.4 1-1V9h6c.6 0 1-.4 1-1s-.4-1-1-1z" />
                  </svg>
                  <span className="//max-xs:sr-only">Adauga</span>
                </button>
                )}
              </div>
            </header>

            <div className="p-2 flex justify-center items-center h-full w-full ">
              <div className="max-h-[70vh] overflow-auto w-full max-w-full">
                <table className="table-auto  w-full ">
                  <thead className="text-xs font-semibold uppercase text-gray-700 dark:text-white bg-gray-100 dark:bg-gray-800">
                    <tr>
                      <th
                        className="p-3 whitespace-nowrap cursor-pointer"
                        onClick={() => setSortConfig((prevConfig) => ({
                          key: "description",
                          direction: prevConfig.key === "description" && prevConfig.direction === "ascending"
                            ? "descending"
                            : "ascending",
                        }))}
                      >
                        <div className="flex items-center gap-2">
                          Denumirea
                          {sortConfig.key === "description" && (
                            <span>{sortConfig.direction === "ascending" ? "▲" : "▼"}</span>
                          )}
                        </div>
                      </th>
                      <th
                        className="p-3 whitespace-nowrap cursor-pointer hidden md:table-cell"
                        onClick={() => setSortConfig((prevConfig) => ({
                          key: "iggroup",
                          direction: prevConfig.key === "iggroup" && prevConfig.direction === "ascending"
                            ? "descending"
                            : "ascending",
                        }))}
                      >
                        <div className="flex items-center gap-2">
                          Grup
                          {sortConfig.key === "iggroup" && (
                            <span>{sortConfig.direction === "ascending" ? "▲" : "▼"}</span>
                          )}
                        </div>
                      </th>
                      <th
                        className="p-3 whitespace-nowrap cursor-pointer hidden md:table-cell"
                        onClick={() => setSortConfig((prevConfig) => ({
                          key: "tip",
                          direction: prevConfig.key === "tip" && prevConfig.direction === "ascending"
                            ? "descending"
                            : "ascending",
                        }))}
                      >
                        <div className="flex items-center gap-2 ">
                          Tip
                          {sortConfig.key === "tip" && (
                            <span>{sortConfig.direction === "ascending" ? "▲" : "▼"}</span>
                          )}
                        </div>
                      </th>
                      <th
                        className="p-3 whitespace-nowrap cursor-pointer"
                        onClick={() => setSortConfig((prevConfig) => ({
                          key: "tip",
                          direction: prevConfig.key === "tip" && prevConfig.direction === "ascending"
                            ? "descending"
                            : "ascending",
                        }))}
                      >
                        <div className="flex items-center gap-2">
                          Adresa
                          {sortConfig.key === "tip" && (
                            <span>{sortConfig.direction === "ascending" ? "▲" : "▼"}</span>
                          )}
                        </div>
                      </th>
                      {/* <th
                        className="p-3 whitespace-nowrap cursor-pointer"
                        onClick={() => setSortConfig((prevConfig) => ({
                          key: "city_name",
                          direction: prevConfig.key === "city_name" && prevConfig.direction === "ascending"
                            ? "descending"
                            : "ascending",
                        }))}
                      >
                        <div className="flex items-center gap-2">
                          Oras / Sat
                          {sortConfig.key === "city_name" && (
                            <span>{sortConfig.direction === "ascending" ? "▲" : "▼"}</span>
                          )}
                        </div>
                      </th>
                      <th
                        className="p-3 whitespace-nowrap cursor-pointer"
                        onClick={() => setSortConfig((prevConfig) => ({
                          key: "region_name",
                          direction: prevConfig.key === "region_name" && prevConfig.direction === "ascending"
                            ? "descending"
                            : "ascending",
                        }))}
                      >
                        <div className="flex items-center gap-2">
                          Regiunea
                          {sortConfig.key === "region_name" && (
                            <span>{sortConfig.direction === "ascending" ? "▲" : "▼"}</span>
                          )}
                        </div>
                      </th>
                      <th
                        className="p-3 whitespace-nowrap cursor-pointer"
                        onClick={() => setSortConfig((prevConfig) => ({
                          key: "district_name",
                          direction: prevConfig.key === "district_name" && prevConfig.direction === "ascending"
                            ? "descending"
                            : "ascending",
                        }))}
                      >
                        <div className="flex items-center gap-2">
                          Raion
                          {sortConfig.key === "district_name" && (
                            <span>{sortConfig.direction === "ascending" ? "▲" : "▼"}</span>
                          )}
                        </div>
                      </th> */}
                      <th className="p-2 hidden md:table-cell">
                        <div className="font-semibold text-center">Statut</div>
                      </th>
                      <th className="p-2 ">
                        <div className="font-semibold text-center">Actiune</div>
                      </th>
                    </tr>
                  </thead>

                  <tbody className="text-sm font-medium divide-y divide-gray-100 dark:divide-gray-700/60">
                    {currentItems.map((customer, index) => {
                      const institutionIds = Adressinst
                        .filter((i) => i.institution_id === customer.institution_id)
                        .map((i) => i.adress_id);
                      const filteredAdress = Adress.filter((i) => institutionIds.includes(i.adress_id));
                      const isSelected = selectedInstitutionId === customer.institution_id;
                      return (
                        <React.Fragment key={customer.institution_id}>
                          {/* Rând principal */}
                          <tr
                            role="button"
                            className={`${index % 2 === 0 ? "bg-gray-0 dark:bg-gray-800" : "bg-gray-100 dark:bg-gray-700"} hover:bg-gray-200 dark:hover:bg-gray-600`}
                          >
                            <td className="p-2 w-[150px] text-break" onClick={() => setSelecteduser(customer)}
                            >
                              <div className="text-left">{customer.description}</div>
                            </td>
                            <td className="p-2 whitespace-nowrap hidden md:table-cell" onClick={() => setSelecteduser(customer)}
                            >
                              <div className="text-left">{customer.iggroup ? customer.iggroup : "no data"}</div>
                            </td>
                            <td className="p-2 whitespace-nowrap hidden md:table-cell">
                              <div className="text-left">{customer.tip}</div>
                            </td>

                            <td className="p-2 whitespace-nowrap">
                              <div className="text-left">
                                {filteredAdress.length >= 1 ? (
                                  <button
                                    className="text-blue-500 underline"
                                    onClick={(e) => {
                                      e.stopPropagation();
                                      setSelectedInstitutionId(isSelected ? null : customer.institution_id);
                                    }}
                                  >
                                    Vezi toate adresele ({filteredAdress.length})
                                  </button>
                                ) : (
                                  <span>Fara date</span>
                                )}
                              </div>
                            </td>
                            <td className="p-2 whitespace-nowrap hidden md:table-cell" onClick={() => setSelecteduser(customer)}
                            >
                              <div className={`text-center font-medium ${customer.is_active ? 'text-green-500' : 'text-red-500'}`}>
                                {customer.is_active ? "Activ" : "Inactiv"}
                              </div>
                            </td>
                            <td>
                              <div className="font-semibold text-center"
                                style={{
                                  fontWeight: "bold",
                                  fontSize: "20px"
                                }}
                              >
                                <IconButton
                                  onClick={() => setSelecteduser(customer)}
                                  color="primary"
                                  sx={{
                                    fontSize: "16px",
                                    borderRadius: "50%",
                                    "&:hover": {
                                      backgroundColor: "#a4adad",
                                    },
                                  }}
                                >
                                  <AiFillEdit className=" dark:text-gray-100" />
                                </IconButton>

                                {/* <IconButton
                                onClick={() => setSelecteddeleteuser(customer)}
                                color="primary"
                                sx={{
                                  fontSize: "16px",
                                  borderRadius: "50%",
                                  "&:hover": {
                                    backgroundColor: "#a4adad",
                                  },
                                }}
                              >
                                <AiOutlineDelete className=" dark:text-gray-100" />
                              </IconButton> */}
                              </div>
                            </td>
                          </tr>

                          {isSelected && (
                            <tr className="bg-gray-50 dark:bg-gray-800">
                              <td colSpan="7" className="p-2">
                                <table className="w-full border border-gray-300 dark:border-gray-600  max-xs:max-h-[30vh]">
                                  <thead className="text-xs uppercase text-gray-500 dark:text-gray-500 bg-gray-100 dark:bg-gray-700 dark:bg-opacity-50 rounded-sm">
                                    <tr>
                                      <th className="p-2">
                                        <div className="font-semibold text-left">Adresa</div>
                                      </th>
                                      <th className="p-2">
                                        <div className="font-semibold text-left">Oras / sat</div>
                                      </th>
                                      <th className="p-2">
                                        <div className="font-semibold text-left">Raion</div>
                                      </th>
                                      <th className="p-2 hidden md:table-cell">
                                        <div className="font-semibold text-left">Regiunea</div>
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {filteredAdress.map((item, idx) => (
                                      <tr key={idx} className="border border-gray-300 dark:border-gray-600">
                                        <td className="p-2 text-left">{item.description}</td>
                                        <td className="p-2 whitespace-nowrap xs:text-wrap">
                                          <div className="text-left">
                                            {item.city_name}
                                          </div>
                                        </td>
                                        <td className="p-2 whitespace-nowrap">
                                          <div className="text-left">
                                            {item.district_name}
                                          </div>
                                        </td>
                                        <td className="p-2 whitespace-nowrap hidden md:table-cell">
                                          <div className="text-left">
                                            {item.region_name}
                                          </div>
                                        </td>
                                      </tr>
                                    ))}
                                  </tbody>
                                </table>
                              </td>
                            </tr>
                          )}
                        </React.Fragment>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>

            <div className="flex justify-center mt-4 mb-4">
              <button
                onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-l-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                disabled={currentPage === 1}
              >
                Prev
              </button>

              {currentPage > 3 && (
                <>
                  <button
                    onClick={() => setCurrentPage(1)}
                    className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                  >
                    1
                  </button>
                  <span className="px-2">...</span>
                </>
              )}

              {Array.from({ length: totalPages }, (_, index) => {
                const page = index + 1;

                if (
                  page === currentPage ||
                  // page === 1 ||
                  // page === totalPages ||
                  (page >= currentPage - 2 && page <= currentPage + 2)
                ) {
                  return (
                    <button
                      key={page}
                      onClick={() => setCurrentPage(page)}
                      className={`px-4 py-2 text-sm font-medium ${currentPage === page
                        ? "bg-gray-500 text-white"
                        : "bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                        }`}
                    >
                      {page}
                    </button>
                  );
                }
                return null;
              })}

              {currentPage < totalPages - 2 && (
                <>
                  <span className="px-2">...</span>
                  <button
                    onClick={() => setCurrentPage(totalPages)}
                    className="px-4 py-2 text-sm font-medium bg-gray-200 dark:bg-gray-700 hover:bg-gray-300 dark:hover:bg-gray-600"
                  >
                    {totalPages}
                  </button>
                </>
              )}

              <button
                onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))}
                className="px-4 py-2 bg-gray-200 dark:bg-gray-700 text-sm font-medium rounded-r-md hover:bg-gray-300 dark:hover:bg-gray-600 disabled:opacity-50"
                disabled={currentPage === totalPages}
              >
                Next
              </button>
            </div>
          </div>
        </>
      )}
    </>
  );
}

export default DashboardCard14;
